import {
  PatchWithMeta,
  PagedResponse,
  QueryParams,
  ValidatedResponse,
} from "@ofqual/portal-core/core/types";
import {
  all,
  call,
  getContext,
  put,
  select,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";

import { linkedRecordsService } from "../services";
import { LOADING_LINKEDRECORDS, CREATING_LINKED_RECORD, REMOVING_LINKED_RECORD } from "./constants";
import { authSelector } from "./selectors";

import { LinkedRecord } from "..//domain/LinkedRecord";
import {
  ActionPayload,
  loadedLinkedRecords,
  loadingLinkedRecords,
} from "./actions";
import { LinkedRecordCreate } from "../domain/LinkedRecordCreate";

function* watchLinkedRecordsSaga() {
  yield takeLatest(LOADING_LINKEDRECORDS, linkedRecordsSaga);
}

function* watchCreateLinkedRecordSaga() {
  yield takeEvery(CREATING_LINKED_RECORD, createLinkedRecordSaga);
}

function* watchRemoveLinkedRecordSaga() {
  yield takeEvery(REMOVING_LINKED_RECORD, removeLinkedRecordSaga);
}

function* linkedRecordsSaga({
  payload,
}: ActionPayload<{
  resourceId: string;
  params: QueryParams;
}>) {
  const { resourceId, params } = payload;
  const { token } = yield select(authSelector);

  const activities: PagedResponse<LinkedRecord> = yield call(
    [linkedRecordsService, linkedRecordsService.search],
    resourceId,
    { ...params },
    { token }
  );
  yield put(loadedLinkedRecords(resourceId, activities));
}

function* createLinkedRecordSaga({
  payload,
}: ActionPayload<{ resourceId: string; linkedRecord: LinkedRecordCreate }>) {
  const { token } = yield select(authSelector);
  const { resourceId, linkedRecord } = payload;

  yield call(
    [linkedRecordsService, linkedRecordsService.postLinkedRecord],
    resourceId,
    linkedRecord,
    { token }
  );
  yield put(loadingLinkedRecords(resourceId));
}

function* removeLinkedRecordSaga({
  payload,
}: ActionPayload<{ id: string, resourceId: string }>) {
  const { token } = yield select(authSelector);
  const { id, resourceId } = payload;

  yield call(
    [linkedRecordsService, linkedRecordsService.deleteLinkedRecord],
    id,
    { token }
  );
  yield put(loadingLinkedRecords(resourceId));
}

export function* rootSaga() {
  yield all([
    watchLinkedRecordsSaga(),
    watchCreateLinkedRecordSaga(), 
    watchRemoveLinkedRecordSaga()
  ]);
}
